import { render, staticRenderFns } from "./EzSortableTable.vue?vue&type=template&id=d90d0660&"
import script from "./EzSortableTable.vue?vue&type=script&lang=js&"
export * from "./EzSortableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports